import React from 'react';
import BtnSubmit from '../../Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../Buttons/BtnWhiteBlackBorderBigSize';

import '../bitPayment.scss';

const CancelPaymentPopupComponent = (props) => {
  return (
    <>
      <div className='cancel-popup-image'>
        <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='m89.28 53.387-2.2-.006v.006h2.2zm5.827 28.097-1.902 1.105.004.007 1.898-1.112zm-2.845 4.979v2.2h.006l-.006-2.2zm-65.336 0-.006 2.2h.006v-2.2zm-2.845-4.98 1.898 1.113.004-.007-1.902-1.106zm5.83-28.096h2.2v-.006l-2.2.006zm18.653 33.076a2.2 2.2 0 1 0-4.4 0h4.4zm26.46 0a2.2 2.2 0 1 0-4.4 0h4.4zM45.831 29.514a27.485 27.485 0 0 1 27.53 0l2.203-3.808a31.885 31.885 0 0 0-31.937 0l2.204 3.808zm27.53 0a27.485 27.485 0 0 1 13.72 23.867l4.4.013a31.885 31.885 0 0 0-15.917-27.688l-2.204 3.808zm13.72 23.873c0 15.118 3.165 24.109 6.124 29.202l3.805-2.21c-2.498-4.3-5.53-12.494-5.53-26.992h-4.4zm6.128 29.209c.2.342.203.765.006 1.109l3.82 2.183a5.507 5.507 0 0 0-.03-5.516l-3.796 2.224zm.006 1.109a1.107 1.107 0 0 1-.958.558l.01 4.4a5.507 5.507 0 0 0 4.768-2.775l-3.82-2.183zm-.953.558H26.926v4.4h65.336v-4.4zm-65.33 0a1.107 1.107 0 0 1-.96-.558l-3.82 2.182a5.507 5.507 0 0 0 4.768 2.775l.011-4.4zm-.96-.558a1.107 1.107 0 0 1 .007-1.11l-3.796-2.224a5.507 5.507 0 0 0-.03 5.516l3.82-2.182zm.01-1.116c2.962-5.094 6.128-14.084 6.128-29.202h-4.4c0 14.497-3.032 22.691-5.531 26.99l3.804 2.212zM32.11 53.38a27.485 27.485 0 0 1 13.72-23.867l-2.203-3.808A31.886 31.886 0 0 0 27.71 53.394l4.4-.013zm12.054 33.082v3.307h4.4v-3.307h-4.4zm0 3.307c0 8.522 6.908 15.43 15.43 15.43v-4.4c-6.092 0-11.03-4.938-11.03-11.03h-4.4zm15.43 15.43c8.522 0 15.43-6.908 15.43-15.43h-4.4c0 6.092-4.938 11.03-11.03 11.03v4.4zm15.43-15.43v-3.307h-4.4v3.307h4.4z'
            fill='#000'
          />
          <path
            d='M83.687 15.14a2.2 2.2 0 0 0-2.349 3.72l2.35-3.72zm12.53 20.246a2.2 2.2 0 0 0 3.946-1.947l-3.946 1.947zm-77.19-1.947a2.2 2.2 0 1 0 3.946 1.947l-3.946-1.947zM37.851 18.86a2.2 2.2 0 1 0-2.349-3.72l2.35 3.72zm43.487 0a40.99 40.99 0 0 1 14.879 16.526l3.946-1.947a45.394 45.394 0 0 0-16.476-18.3l-2.349 3.721zM22.973 35.386A40.991 40.991 0 0 1 37.85 18.86l-2.349-3.72a45.39 45.39 0 0 0-16.475 18.299l3.946 1.947z'
            fill='var(--theme-primary, #810ea9)'
          />
        </svg>
      </div>
      <div className='bit-cancel-popup-text'>
        {' '}
        רוצה לבטל את <br />
        התשלום ב-bit?
      </div>
      <BtnSubmit
        text='המשך לתשלום ב-bit'
        onclick={() => {
          props.setReuse(true);
        }}
      />
      <BtnWhiteBlackBorderBigSize
        text='כן, רוצה לבטל'
        onclick={() => {
          props.closePopup();
        }}
      />
    </>
  );
};

export default CancelPaymentPopupComponent;
